const DOMAIN_LIST_CACHE_ID = 'DomainList';

const DOMAIN_LIST_EVENT = {
  UPDATE: 'UpdateDomainList',
  UPDATE_COUNT: 'UpdateDomainsCount',
};

export {DOMAIN_LIST_CACHE_ID, DOMAIN_LIST_EVENT};
